import axios from 'axios';
import { useQuery } from 'react-query';

import { useSessionStore } from 'session/useSessionStore';

export function useGetFileInfo(fileName: string | (string | null)[] | null) {
    const {tenantConfig, jwtToken} = useSessionStore(state => ({
        tenantConfig: state.tenantConfiguration,
        jwtToken: state.jwtToken
    }));

    return useQuery(['getFileInfo', fileName], async () => {
        const response = await axios.get(`${tenantConfig?.endpoints.render}/FilesViewer/GetFileInfo?fileName=${fileName}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`
            },
        });

        return response.data;
    }, {
        refetchOnWindowFocus: false,
        enabled: fileName !== null && fileName !== undefined && fileName !== '',
    });
}

export function useGetFilePathAndInfo(fileToken: string | (string | null)[] | null, execute: boolean) {
    const {tenantConfig, jwtToken} = useSessionStore(state => ({
        tenantConfig: state.tenantConfiguration,
        jwtToken: state.jwtToken
    }));

    return useQuery(['getFilePathAndInfo', fileToken], async () => {
        const response = await axios.get(`${tenantConfig?.endpoints.fileIndexing}/FileManager/FileManager/GetFilePathAndInfo?fileToken=${fileToken}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`
            },
        });

        return response.data.Result;
    }, {
        refetchOnWindowFocus: false,
        enabled: fileToken !== null && fileToken !== undefined && fileToken !== '' && execute,
    });
}